export const NetworkingError = 'NetworkingError';
export const RequestAbortedError = 'RequestAbortedError';
